<fa-icon icon="info-circle"></fa-icon> <span [innerHTML]="message"></span>

<div class="items">
  <span *ngFor="let item of items" class="item">
    <astrobin-equipment-item-display-name [item]="item"></astrobin-equipment-item-display-name>
  </span>
</div>
